import { connect } from "react-redux"
import { load_user } from "../../redux/actions/auth/auth"
import { useNavigate } from 'react-router-dom';

import { useEffect, useState } from 'react'
import L from 'leaflet'
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import { useDebouncedCallback } from 'use-debounce';
import axios from "axios"

  function ChangeView({center}){
    const map = useMap();

    useEffect(()=>{
      map.setView(center)
    }, [center])
     
    return null
  }

  function NewTrip({
    load_user,
  }) {

    const navigate = useNavigate();

    const [steps, setSteps] = useState(0);
    const [tripAux, setTripAux] = useState({
      max_passengers: 1,
      pickup_time: null,
      pickup_location: null,
      event: null
    })

    //-------------------------- STEP 0 -----------------------------

    const [eventsOptions, setEventsOptions] = useState([])
    const [query, setQuery] = useState("")
    const [mensaje, setMensaje] = useState("")
    
    const fetchData = async (value) => {
      const config = {
        headers: {
            'Accept': 'application/json'
        }
      };
      if (value.trim() !== "") {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/events/options?evento=${encodeURIComponent(value)}`, config);
          if (res.status === 200) {
              setEventsOptions(res.data.eventos)
              if(res.data.eventos.length > 0){
                setMensaje("")
              }else{
                setMensaje("No hay resultados para esta busqueda")
              }
          } else {
              setEventsOptions([])
              setMensaje("No hay resultados para esta busqueda")
          }
        } catch (err) {
            setEventsOptions([])
            setMensaje("No hay resultados para esta busqueda")
        } finally {
            
        }
      }else{
        setMensaje("")
      }
    };

    const debouncedFetch = useDebouncedCallback(fetchData, 500);
    const handleChangeEvento = async (e) => {
        const value = e.target.value;
        setEventsOptions([])
        setTripAux(prev => ({
          ...prev,
          event: null
        }))
        if (value.trim() !== "") {
          setMensaje("cargando")
        }
        setQuery(value);
        debouncedFetch(value);
    };

    function obtenerDatosFecha(fechaStr) {
      const fecha = new Date(fechaStr);
      const dia = fecha.getUTCDate();
      const año = fecha.getUTCFullYear();
      const mes = new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(fecha);
      const mesCapitalizado = mes.charAt(0).toUpperCase() + mes.slice(1);
      
      return `${dia}, ${mesCapitalizado} de ${año}`;
    }

    //-------------------------- STEP 1 ----------------------------

    const [position, setPosition] = useState([40.444071, -3.690899]);
    const [markerposition, setMarkerPosition] = useState(null);
    const [direccionSelected, setDireccionSelected] = useState("");
    const [searchLocation, setSearchLocation] = useState("");

    const customMarkerIcon = L.divIcon({
      html: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
            </svg>
            `,
      className: "text-blue-green",
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32]
    });
  
    const MapClickHandler = () => {
      useMapEvents({
        click(e) {
          setMarkerPosition([e.latlng.lat, e.latlng.lng]);
          getDireccion([e.latlng.lat, e.latlng.lng]);
        },
      });
      return null;
    };
  
    const handleSearchLocation = async () => {
      const apiKey = "8bfeddfd03c84eeaa79fbd9decb75d18";
      const url = `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(searchLocation)}&key=${apiKey}`;
      if(searchLocation.trim() !== ""){
        try {
          console.log("ups")
          const response = await fetch(url);
          const data = await response.json();
          if (data.results.length > 0) {
            const { lat, lng } = data.results[0].geometry;
            setPosition([lat, lng]);
            setMarkerPosition([lat, lng]);
            await getDireccion([lat, lng]);
          } else {
          }
        } catch (error) {
        }
      }
    };

    const getDireccion = async (dir) => {
      const apiKey = "8bfeddfd03c84eeaa79fbd9decb75d18";
      const url = `https://api.opencagedata.com/geocode/v1/json?q=${dir[0]}%2C${dir[1]}&key=${apiKey}`
      try {
        const response = await fetch(url);
        const data = await response.json();
        setDireccionSelected(data.results[0]?.formatted)
      } catch (error) {
      }
    };
    
    //-------------------------- STEP 2 ----------------------------



    //-------------------------- STEP 3 ----------------------------

    const handleCancelNewTrip = function(){
      setTripAux({
        max_passengers: 1,
        pickup_time: null,
        pickup_location: null,
        event: null
      })
      setSearchLocation("")
      setDireccionSelected("")
      setMarkerPosition(null)
      setPosition([40.444071, -3.690899])
      setEventsOptions([])
      setQuery("")
      setMensaje("")
      setSteps(0)
      navigate('/');
    }

    const create_trip = async (data) => {
      if (localStorage.getItem('access')) {
  
        const body = data;
        const config = {
            headers: {
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        };

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/trip/new`, body, config);
            if (res.status === 200) {
            } else {
            }
        } catch (err) {
        } finally {
        }
      }else{
      }
    }
      
    const createTrip = async function(){
      if (tripAux){
        const tripData = {
          ...tripAux,
          pickup_location: {
            address: direccionSelected,
            latitude: parseFloat(markerposition[0].toFixed(6)),
            longitude: parseFloat(markerposition[1].toFixed(6)),
          },
        };
        
        await create_trip(tripData)
        await load_user()
        handleCancelNewTrip()
      }
    }

    return (
     
    <div className="flex-1 h-full w-full px-4 bg-white flex justify-center">
        <div className={`h-full mt-8 ${steps === 0 ? "block" : "hidden"}`}>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-700 mb-10">
                ¿A que evento vas?
            </h1>

            <input
                  type="text"
                  value={query}
                  onChange={handleChangeEvento}
                  placeholder="Encuentra tu evento..."
                  className="border py-2 px-6 rounded-3xl w-full mb-5 outline-none focus:outline-none focus:ring-0 focus:border-black"
            />

            <div className="max-h-96 overflow-y-auto">
              {!mensaje ? (eventsOptions.map((item, idx) => ( 
                <button onClick={()=>setTripAux(prev => ({
                          ...prev,
                          event: item.id
                        }))}
                        key={idx} className={`w-full flex items-center gap-x-5 mb-5 rounded-3xl p-2 ${tripAux.event === item.id ? "border-2 border-blue-green" : "border-2 border-transparent"}`}>
                    <img
                        src={`${item.thumbnail}`}
                        className="object-cover h-24 w-24 rounded-xl"
                    />
                    <div className="flex flex-col items-start">
                        <p className="font-semibold text-lg">{item.title}</p>
                        <div className="flex items-center gap-x-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                            </svg>
                            <p className="pb-2">{item.ciudad.name}</p>
                        </div>
                        <div className="flex items-center gap-x-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                            </svg>
                            <p className="">{obtenerDatosFecha(item.fecha)}</p>
                        </div>
                    </div>
                </button>
              ))):
              (
                <p className="text-center">{mensaje}</p>
              )}
            </div>
            <button onMouseDown={()=>{setSteps(1)}} className={`mt-5 p-2 w-full border rounded-3xl bg-blue-green text-white ${tripAux.event ? " hover:bg-blue-green-dark" : "hidden"}`}>
                Siguiente
            </button>
        </div>
        <div className={`w-full grid md:grid-cols-2 ${steps === 1 ? "block" : "hidden"}`}>
            <div className="mt-8 md:mt-32 col-span-1 flex flex-col items-center md:px-28">
                <button className="group mb-2 flex items-center text-lg" onClick={()=>{setSteps(0)}}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 group-hover:-translate-x-1 transition duration-300">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                    </svg> Atrás
                </button>
                <h1 className="text-4xl md:text-5xl font-bold text-gray-700">
                    ¿Desde donde sales?
                </h1>
                <p className="text-gray-700 mt-4 text-sm">Puedes seleccionar una ubicacion en el mapa o indicar la direccion directamente</p>
                <div className="flex mt-5 w-full">
                    <input
                        type="text"
                        id="searchLocation"
                        value={searchLocation}
                        onChange={(e) => setSearchLocation(e.target.value)}
                        placeholder="Direccion"
                        className="border flex-1 py-2 px-6 rounded-l-3xl w-full outline-none focus:outline-none focus:ring-0 focus:border-black"
                    />
                    <button
                        type="button"
                        onClick={handleSearchLocation}
                        className="px-4 py-2 bg-blue-green text-white rounded-r-3xl hover:bg-blue-green-dark"
                    >
                        Buscar
                    </button>
                </div>
                {direccionSelected&&
                  <div className="flex items-center gap-x-2 mt-10">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-10 text-red-600">
                      <path fillRule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clipRule="evenodd" />
                    </svg>

                    <p>{direccionSelected}</p>
                  </div>
                }
                <button onClick={()=>{setSteps(2)}} className={`mt-10 py-2 px-16 border rounded-3xl bg-blue-green text-white ${markerposition&&direccionSelected ? " hover:bg-blue-green-dark" : "hidden"}`}>
                    Siguiente
                </button>
            </div>
            <div className="col-span-1 h-full w-full md:p-6">
                <MapContainer center={position} zoom={13} className="rounded-3xl w-full" style={{position: "relative", height: "100%", zIndex: 1}}>
                    <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"/>
                    <ChangeView center={position}/>
                    <MapClickHandler />

                    {markerposition&&<Marker position={markerposition} icon={customMarkerIcon} />}
                </MapContainer>
            </div>
        </div>
        <div className={`mt-8 md:mt-32 flex flex-col items-center ${steps === 2 ? "block" : "hidden"}`}>
            <button className="group mb-2 flex items-center text-lg" onClick={()=>{setSteps(1)}}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 group-hover:-translate-x-1 transition duration-300">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                </svg> Atrás
            </button>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-700">
                ¿A que hora sales?
            </h1>
            <input
                type="time"
                id="pickup_time"
                name='pickup_time'
                value={tripAux.pickup_time}
                onChange={(e) => setTripAux(prev => ({
                  ...prev,
                  pickup_time: e.target.value
                }))}
                className="mt-10 rounded-3xl border-gray-300 shadow-sm text-2xl p-4"
            />
            <button onClick={()=>{setSteps(3)}} className={`mt-10 py-2 px-16 border rounded-3xl bg-blue-green text-white ${tripAux.pickup_time ? " hover:bg-blue-green-dark" : "hidden"}`}>
                Siguiente
            </button>
        </div>
        <div className={`mt-8 md:mt-32 flex flex-col items-center ${steps === 3 ? "block" : "hidden"}`}>
            <button className="group mb-2 flex items-center text-lg" onClick={()=>{setSteps(2)}}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 group-hover:-translate-x-1 transition duration-300">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                </svg> Atrás
            </button>
            <h1 className="text-4xl md:text-5xl max-w-lg text-center font-bold text-gray-700">
                ¿Cuantos pasajeros quieres llevar?
            </h1>
            <input
                type="number"
                id="max_passengers"
                name="max_passengers"
                value={tripAux.max_passengers}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value >= 1 && value < 11) {
                    setTripAux(prev => ({
                      ...prev,
                      max_passengers: value
                    }));
                  }
                }}
                min="1"
                max="10"
                className="mt-10 rounded-3xl border-gray-300 shadow-sm text-2xl p-4"
            />
            <div className="flex items-center gap-x-4 mt-10">
              <button onClick={handleCancelNewTrip} className={`mt-5 px-5 py-3 border rounded-3xl bg-gray-300 text-white hover:bg-gray-400`}>
                  Cancelar
              </button>
              <button onClick={createTrip} disabled={!tripAux.max_passengers} className={`mt-5 px-5 py-3 w-full border rounded-3xl bg-blue-green text-white ${tripAux.max_passengers ? " hover:bg-blue-green-dark" : "opacity-50"}`}>
                  Publicar Trip
              </button>
            </div>
        </div>
     </div>
    )
  }

  const mapStateToProps=state=>({
  })

  export default connect(mapStateToProps,{
    load_user,
  })(NewTrip)